import { lbApiBeta, lbPropositionApi } from '../../../utils/axiosConfig';
import { formatResidenceAddress } from '@/utils/helpers/residence';

async function hasActiveMatches({ propositionId, propositionId2 }) {
  try {
    const { data } = await lbApiBeta.get(
      `/api/matches/v2/has-active/${propositionId}/${propositionId2}`
    );
    return data;
  } catch (e) {
    throw Error(e);
  }
}

async function fetchPropositionAddress(propositionId) {
  const { data } = await lbPropositionApi.get(`/propositions/${propositionId}`);
  return [data?.residences?.[0], data?.residences?.[1]]
    .map(formatResidenceAddress)
    .filter(Boolean)
    .join(' & ');
}

async function markInterest({
  propositionId,
  propositionId2,
  interest,
  source,
  triggeredFromSection
}) {
  try {
    const { data } = await lbApiBeta.post('/api/v2/interest/mark-interest', {
      propositionId,
      propositionId2,
      interest,
      source,
      triggeredFromSection
    });
    return data;
  } catch (e) {
    throw Error(e);
  }
}

async function setInterestLevel({
  propositionId,
  propositionId2,
  propositionId3,
  interestLevel
}) {
  try {
    const { data } = await lbApiBeta.post('/api/v2/interest/level', {
      propositionId,
      propositionId2,
      propositionId3,
      interestLevel
    });
    return data;
  } catch (e) {
    throw Error(e);
  }
}

export default {
  hasActiveMatches,
  fetchPropositionAddress,
  markInterest,
  setInterestLevel
};
